/** Anchor longitude for 90° band site fill (SW US / Kitt Peak). */
export const SW_US_ANCHOR_LON = -111.5967;

export const STRATEGIC_LOCATIONS = [
  { id: 'hawaii', lat: 19.82067, lon: -155.46806, name: 'Hawaii' },
  { id: 'sw-us', lat: 31.9583, lon: -111.5967, name: 'SW US' },
  { id: 'chile', lat: -23.86321, lon: -69.14175, name: 'Chile' },
  { id: 'canary', lat: 28.7606, lon: -17.8899, name: 'Canary Islands' },
  { id: 'portugal', lat: 39.6036, lon: -8.4008, name: 'Portugal' },
  { id: 'spain', lat: 37.2236, lon: -2.5461, name: 'Spain' },
  { id: 'austria', lat: 47.5162, lon: 14.5501, name: 'Austria' },
  { id: 'south-africa', lat: -32.3797, lon: 20.8107, name: 'South Africa' },
  { id: 'india', lat: 34.1458, lon: 77.5764, name: 'India' },
  { id: 'w-australia', lat: -31.9831, lon: 115.8187, name: 'W Australia' },
  { id: 'japan', lat: 35.3733, lon: 137.0156, name: 'Japan' },
  { id: 'e-australia', lat: -31.2733, lon: 149.0674, name: 'E Australia' },
  { id: 'new-zealand', lat: -43.9855, lon: 170.4659, name: 'New Zealand' },
  { id: 'guam', lat: 13.4443, lon: 144.7937, name: 'Guam' },
  { id: 'diego-garcia', lat: -7.3133, lon: 72.4118, name: 'Diego Garcia' },
  { id: 'jordan', lat: 31.7683, lon: 35.2137, name: 'Jordan' },
  { id: 'fiji', lat: -17.7134, lon: 178.0650, name: 'Fiji' },
];

const BIN_COUNT = 4;

/**
 * 90° longitude bin relative to anchor (0 = Americas band from SW US).
 */
export function longitudeBin(lon, anchorLon = SW_US_ANCHOR_LON) {
  const offset = ((lon - anchorLon) % 360 + 360) % 360;
  return Math.min(BIN_COUNT - 1, Math.floor(offset / 90));
}

/**
 * Round-robin fill across 90° bins (SW US first in bin 0), W→E within each bin.
 */
export function buildStrategicSiteOrder(
  locations = STRATEGIC_LOCATIONS,
  anchorLon = SW_US_ANCHOR_LON,
) {
  const bins = Array.from({ length: BIN_COUNT }, () => []);

  for (const location of locations) {
    const bin = longitudeBin(location.lon, anchorLon);
    bins[bin].push(location);
  }

  for (const bin of bins) {
    bin.sort((a, b) => a.lon - b.lon);
  }

  const maxDepth = Math.max(...bins.map((bin) => bin.length), 0);
  const ordered = [];

  for (let round = 0; round < maxDepth; round += 1) {
    for (let bin = 0; bin < BIN_COUNT; bin += 1) {
      if (bins[bin][round]) {
        ordered.push(bins[bin][round]);
      }
    }
  }

  return ordered;
}
